import { useState } from "react";
import { globalVariables } from "../../../../global/GlobalVariables";
import { Button, Grid, Link, Typography } from "@mui/material";
import { postNotification } from "../../../../components/utilities/Notifications";
import ModalLoadingFull from "../../../../components/modals/ModalLoadingFull";
import { getData } from "../../../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../../../global/environmentVariables";
import { StripeIcon } from "../../../../components/icons/payment/StripeIcon";
const IS_BCP = getEnvironmentVariable("IS_BCP") === "true";

export default function BankDetailsTab(props) {
  const { user, authContext } = props;
  const [processing, setProcessing] = useState(false);
  const globalVars = globalVariables();

  const isAdmin = authContext?.authState?.identity?.isAdmin || false;

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h3" gutterBottom>
            Want to sell tickets to your events?
          </Typography>

          {IS_BCP ? (
            <Typography variant="body1" paragraph>
              {globalVars?.site?.title} provide Event Organizers with a simple
              way to register and process payments for events!
            </Typography>
          ) : (
            <Typography variant="body1" paragraph>
              {globalVars?.site?.title} has partnered with Best Coast Pairings
              to provide Event Organizers with a simple way to register and
              process payments for events!
            </Typography>
          )}
          <Typography variant="body1" paragraph>
            {`This powerful tool is powered by the secure and trusted `}
            <Link
              href="https://stripe.com/"
              target="_Blank"
              underline="none"
              sx={{ color: "link.stripe" }}
            >
              Stripe
            </Link>{" "}
            {isAdmin && (
              <>
                and{" "}
                <Link
                  href="https://squareup.com/us/en"
                  target="_Blank"
                  underline="none"
                  sx={{ color: "link.square" }}
                >
                  Square
                </Link>
              </>
            )}
            {` payment platform${isAdmin ? "s" : ""}. Event Organizers can attach a Business Account, Debit Card or personal checking account to their ${getEnvironmentVariable("APP_NAME") || "BCP"} account and once enabling online registration within Event Details, can set the price for  2-3 days of purchase. You can find more information on our `}
            <Link href="/pricing" target="_Blank" underline="none" color="link">
              Pricing
            </Link>{" "}
            {`page.`}
          </Typography>
        </Grid>

        {/* Payment Processor Buttons */}

        {/* Stripe */}
        <Grid item xs={12}>
          <Button
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: "link.stripe",
              color: "#000",
              "&:hover": {
                backgroundColor: "primary.main",
                color: "#fff",
              },
            }}
            startIcon={<StripeIcon />}
            onClick={async () => {
              if (user?.bankAccount?.id) {
                setProcessing(true);
                try {
                  var link = await getData(
                    `/stripe/expresslink/${user.bankAccount.id}`
                  );

                  window.open(link.url, "popup");
                } catch (err) {
                  postNotification("error", err);
                }
                setProcessing(false);
              } else {
                var addParams = `?redirect_uri=${window.location.origin}/stripe/account-creation`;
                if (user.email) {
                  addParams = addParams + "&stripe_user[email]=" + user.email;
                }
                addParams =
                  addParams + "&stripe_user[first_name]=" + user.firstName;
                addParams =
                  addParams + "&stripe_user[last_name]=" + user.lastName;
                addParams =
                  addParams +
                  `&state=${user.id}&client_id=${getEnvironmentVariable(
                    "STRIPE_CLIENT_ID"
                  )}`;

                window.location.assign(
                  "https://connect.stripe.com/express/oauth/authorize" +
                    addParams
                );
              }
            }}
          >
            {user?.bankAccount?.id
              ? "Update Stripe Bank Account"
              : "Link Bank Account with Stripe"}
          </Button>
        </Grid>
      </Grid>

      {Boolean(processing) && <ModalLoadingFull />}
    </>
  );
}
